import React, { useMemo } from "react";
import Icon from "./icon";

const SocialIcons = ({ socialIcons, followUs }) => {
  const socialSorted = useMemo(() => {
    return socialIcons?.pages
      .filter((page) => page.page?.hasBody || page.page?.hasProdotti || page.page?.externalLink)
      .sort((a, b) => {
        const posA = parseInt(
          a.hooverStPosition?.position?.length ? a.hooverStPosition?.position[0] : 0
        );
        const posB = parseInt(
          b.hooverStPosition?.position?.length ? b.hooverStPosition?.position[0] : 0
        );
        return !isNaN(posA) && !isNaN(posB) ? posA - posB : isNaN(posA) ? 1 : -1;
      });
  }, [socialIcons]);

  return (
    <div className="footer__colDx">
      {followUs && <span className="footer__social-title">{followUs}</span>}
      <div className="icons">
        {socialSorted.map((page, i) => (
          <div className="icon-container" key={i}>
            <a href={page.page.externalLink} target={page.hooverStTarget.target}>
              {page.page.hooverStIcons.alternativeIcon || page.page.hooverStIcons.icon ? (
                <Icon
                  className={`social-${page.page.hooverStIcons.icon}`}
                  name={
                    page.page.hooverStIcons.alternativeIcon
                      ? "custom"
                      : "social-" + page.page.hooverStIcons.icon
                  }
                  url={
                    page.page.hooverStIcons.width || page.page.hooverStIcons.height
                      ? page.page.hooverStIcons.alternativeIcon?.node?.publicURL
                      : page.page.hooverStIcons.alternativeIcon?.node?.resize?.src
                  }
                  width={page.page.hooverStIcons.width}
                  height={page.page.hooverStIcons.height}
                  alt={
                    page.page.hooverStIcons.alternativeIcon
                      ? page.page.hooverStIcons.alternativeIcon.value?.description
                      : ""
                  }
                />
              ) : null}
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SocialIcons;
